import { DataModelLayout, LayoutSection } from '@/types/DataModel';

const DAM_CARD_LAYOUT = 'asset_card';

const DAM_CARD_SLOTS = ['TOP_BADGES', 'BOTTOM_BADGES', 'TITLE', 'BODY', 'FOOTER'] as const;

type DamCardSlot = typeof DAM_CARD_SLOTS[number];

type DamCardSectionAttribute = LayoutSection['attributes'][number];

type DamCardSections = Record<DamCardSlot, DamCardSectionAttribute[]>;

/** Attributes per card area, taken from the sections of the `asset_card` layout by name. */
const resolveDamCardSections = (layout: DataModelLayout | undefined): DamCardSections => {
    const sections = Object.fromEntries(DAM_CARD_SLOTS.map((slot) => [slot, []])) as unknown as DamCardSections;

    for (const section of layout?.sections ?? []) {
        if ((DAM_CARD_SLOTS as readonly string[]).includes(section.name)) {
            sections[section.name as DamCardSlot] = (section.attributes ?? []).filter((attribute) => !attribute.hidden);
        }
    }

    return sections;
};

export { DAM_CARD_LAYOUT, resolveDamCardSections };
export type { DamCardSectionAttribute, DamCardSections, DamCardSlot };
